import { decodeHtmlEntity } from "@/helpers/common/ParseHtml";

const Descripation = ({ description }) => {
  return (
    <>
      {Array.isArray(description) ? (
        description?.map((item, idx) => (
          <div
            key={idx}
            dangerouslySetInnerHTML={{
              __html: decodeHtmlEntity(item)
                ?.replaceAll(
                  '"{{media url="',
                  `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
                )
                ?.replaceAll(`/media/" `, "/media/")
                ?.replaceAll('"}}"', "")
                ?.replaceAll(
                  "{{media url=",
                  `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
                )
                ?.replaceAll("}}", ""),
            }}
            className="text-zinc-400 text-justify relative"
          ></div>
        ))
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: decodeHtmlEntity(description)
              ?.replaceAll(
                '"{{media url="',
                `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
              )
              ?.replaceAll(`/media/" `, "/media/")
              ?.replaceAll('"}}"', "")
              ?.replaceAll(
                "{{media url=",
                `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
              )
              ?.replaceAll("}}", ""),
          }}
          className="text-zinc-400 text-justify relative"
        />
      )}
    </>
  );
};

export default Descripation;
